import blogManifest from "./blogs/blogManifest.json";

const bySlug = (slug) => {
  const metadata = blogManifest.find((item) => item.slug === slug);
  if (!metadata) throw new Error(`Missing blog route for ${slug}`);
  return metadata;
};

const menopause = bySlug("por-que-subes-de-peso-en-la-menopausia");
const timeForFamily = bySlug("tiempo-para-los-tuyos");
const agingWell = bySlug("miedo-a-envejecer-y-verse-bien");
const sleepWell = bySlug("dormir-de-verdad");

export const MENOPAUSE_BLOG_PATH = menopause.path;
export const MENOPAUSE_BLOG_SLUG = menopause.slug;
export const MENOPAUSE_BLOG_CANONICAL = menopause.canonical;

export const TIME_FOR_FAMILY_BLOG_PATH = timeForFamily.path;
export const AGING_WELL_BLOG_PATH = agingWell.path;
export const SLEEP_WELL_BLOG_PATH = sleepWell.path;

export const BLOG_ROUTES = blogManifest.map(({ canonical, legacy, path, slug }) => ({
  canonical,
  legacy: Boolean(legacy),
  path,
  slug,
}));

export const EXPANDED_BLOG_ROUTES = BLOG_ROUTES.filter(({ legacy }) => !legacy);
